const MEDIA_ITEMS = [
  {
    title: '《星辰大海》幕后花絮',
    desc: '独家探班花絮，主演畅谈角色幕后故事',
    duration: '12:35',
    cover: 'https://readdy.ai/api/search-image?query=A%20cinematic%20behind%20the%20scenes%20atmosphere%20with%20warm%20studio%20lighting%2C%20a%20film%20set%20with%20cameras%20and%20soft%20golden%20backlight%2C%20artistic%20depth%20of%20field%2C%20dark%20cinematic%20mood%20with%20amber%20highlights%2C%20entertainment%20production%20aesthetic&width=800&height=500&seq=media-card-01&orientation=landscape',
  },
  {
    title: '2026夏季剧场预告合集',
    desc: '20部热门新剧抢先看，精彩不容错过',
    duration: '05:48',
    cover: 'https://readdy.ai/api/search-image?query=A%20dramatic%20movie%20trailer%20compilation%20visual%20with%20multiple%20overlapping%20cinematic%20frames%2C%20vibrant%20warm%20golden%20and%20coral%20color%20accents%2C%20dark%20theatrical%20background%2C%20dynamic%20composition%20with%20motion%20energy%2C%20entertainment%20marketing%20aesthetic&width=800&height=500&seq=media-card-02&orientation=landscape',
  },
  {
    title: '《流浪地球3》导演专访',
    desc: '科幻巨制背后的创作心路与特效揭秘',
    duration: '18:20',
    cover: 'https://readdy.ai/api/search-image?query=A%20futuristic%20sci-fi%20interview%20setting%20with%20holographic%20displays%20and%20blue-gold%20atmospheric%20lighting%2C%20cinematic%20space%20theme%2C%20professional%20studio%20environment%20with%20technology%20elements%2C%20dark%20ambient%20mood%2C%20premium%20production%20design&width=800&height=500&seq=media-card-03&orientation=landscape',
  },
  {
    title: '《极限挑战》未播片段',
    desc: '爆笑名场面合集，承包你一整天的快乐',
    duration: '08:12',
    cover: 'https://readdy.ai/api/search-image?query=A%20fun%20variety%20show%20outdoor%20scene%20with%20bright%20warm%20sunlight%2C%20playful%20group%20activity%20atmosphere%2C%20colorful%20casual%20setting%2C%20energetic%20and%20joyful%20mood%2C%20entertainment%20reality%20show%20aesthetic%20with%20natural%20greenery&width=800&height=500&seq=media-card-04&orientation=landscape',
  },
  {
    title: '动漫新番导视 · 7月篇',
    desc: '《鬼灭之刃》《咒术回战》等新番速览',
    duration: '06:30',
    cover: 'https://readdy.ai/api/search-image?query=An%20anime%20showcase%20visual%20with%20stylized%20illustration%20style%2C%20vibrant%20warm%20color%20palette%20with%20gold%20and%20coral%20accents%2C%20dark%20background%20with%20floating%20character%20silhouettes%2C%20dynamic%20composition%2C%20anime%20promotion%20aesthetic%20with%20dramatic%20lighting&width=800&height=500&seq=media-card-05&orientation=landscape',
  },
];

export default function MediaSection() {
  return (
    <section id="media" className="py-14 md:py-20 bg-background-50">
      <div className="mx-auto max-w-[1400px] px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading font-black text-foreground-50">
            精彩预告
          </h2>
          <p className="mt-3 text-sm text-foreground-500 max-w-lg mx-auto">
            花絮、专访、预告片，更多影视周边精彩内容
          </p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {MEDIA_ITEMS.map((item, idx) => (
            <div
              key={idx}
              className="group rounded-xl overflow-hidden bg-background-100 border border-background-300/15 hover:border-background-300/30 transition-all cursor-pointer"
            >
              <div className="relative aspect-video overflow-hidden bg-background-200">
                <img
                  src={item.cover}
                  alt={item.title}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                  onError={(e) => {
                    (e.currentTarget as HTMLElement).style.display = 'none';
                  }}
                />
                <div className="absolute inset-0 bg-gradient-to-t from-background-950/60 via-transparent to-transparent"></div>
                <div className="absolute bottom-3 left-3 flex items-center gap-2">
                  <div className="w-8 h-8 flex items-center justify-center rounded-full bg-primary-500/90 text-background-950">
                    <i className="ri-play-fill text-sm"></i>
                  </div>
                  <span className="text-xs text-foreground-100 bg-background-950/60 px-2 py-0.5 rounded-full">
                    {item.duration}
                  </span>
                </div>
              </div>
              <div className="p-4">
                <h3 className="text-sm md:text-base font-heading font-bold text-foreground-100 group-hover:text-primary-400 transition-colors">
                  {item.title}
                </h3>
                <p className="mt-1 text-xs text-foreground-500 line-clamp-2">
                  {item.desc}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}